import { URGENCY_LABELS } from '@civilos/domain';
import { fmtDate } from './format.ts';
import { Badge } from './ui.tsx';
import { ServiceCircles } from '../field/circles.tsx';

/** Deterministic rules evaluation display (internal only — never shown to customers). */
export function RulesPanel({ ev, compact = false }: { ev: any; compact?: boolean }) {
  if (!ev) return null;
  const a = ev.attemptNow;
  const ns = ev.nonService;
  const u = ev.urgency;
  return (
    <div className="stack sm">
      <div className="row gap wrap">
        {a.notAssigned ? (
          <Badge tone="neutral">Not attemptable in current status</Badge>
        ) : a.allowed ? (
          <Badge tone="ok">Attempt allowed now</Badge>
        ) : (
          <Badge tone="bad">Attempt blocked now</Badge>
        )}
        <Badge tone={u.tier === 'supervisor_urgent' ? 'bad' : u.tier === 'late_received_priority' ? 'warn' : 'neutral'}>{URGENCY_LABELS[u.tier as keyof typeof URGENCY_LABELS]}</Badge>
        {u.cutoffDate && (
          <span className="muted small">
            Cutoff {fmtDate(u.cutoffDate)} ({u.daysRemaining} day{Math.abs(u.daysRemaining) === 1 ? '' : 's'})
          </span>
        )}
        <span className="muted small">Rules v{ev.ruleVersion}</span>
      </div>
      {(ev.windows || ev.vacate) && <ServiceCircles ev={ev} />}
      {!a.notAssigned && [...a.blockers, ...a.warnings].length > 0 && (
        <ul className="issues">
          {a.blockers.map((b: any) => (
            <li key={b.code} className="bad">
              {b.message}
            </li>
          ))}
          {a.warnings.map((w: any) => (
            <li key={w.code} className="warn">
              {w.message}
            </li>
          ))}
        </ul>
      )}
      {!compact && (!a.notAssigned || ns.satisfied) && (
        <div className="ns">
          <div className="row gap">
            <strong>Non-service requirements</strong>
            {ns.satisfied ? <Badge tone="ok">Satisfied{ns.basis === 'immediate_disposition' ? ' (immediate disposition)' : ''}</Badge> : <Badge tone="warn">Not yet satisfied</Badge>}
          </div>
          {Object.keys(ns.windowCoverage).length > 0 && (
            <div className="small muted">
              Windows covered: {Object.entries(ns.windowCoverage).map(([w, c]: [string, any]) => `${w}${c.viaSaturdayWildcard ? ' (Saturday wildcard)' : ''}`).join(', ')}
            </div>
          )}
          {!ns.satisfied && (
            <ul className="issues">
              {ns.missing.map((m: string, i: number) => (
                <li key={i}>{m}</li>
              ))}
            </ul>
          )}
        </div>
      )}
      {ev.eviction && (
        <div className="small">
          <strong>Eviction timing: </strong>
          {ev.eviction.postingEligibleFromDate ? `attempt 3 / posting allowed from ${fmtDate(ev.eviction.postingEligibleFromDate)}` : ev.eviction.notes.at(-1)}
        </div>
      )}
      {u.reasons.length > 0 && <div className="small muted">Urgency: {u.reasons.join(' ')}</div>}
    </div>
  );
}
